import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

const styles = (theme: Theme) =>
    createStyles({
        teaserContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: theme.spacing(2),
            height: '80vh',
            width: '100%',
            position: 'relative',
            minHeight: '700px',
        },
        imageContainer: {
            width: '80%',
            maxWidth: '680px', // 680px is the width of the image in Figma
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        image: {
            width: '100%',
        },
        text: {
            textAlign: 'center',
        },
        buttonsContainer: {
            marginTop: theme.spacing(2),
        },
        button: {
            fontWeight: theme.typography.fontWeightSemiBold,
            display: 'inline-block',
            minWidth: '250px',
            minHeight: '45px',
            margin: theme.spacing(1),
            [theme.breakpoints.only('xs')]: { width: '95%' },
        },
    });

const options = {
    name: 'CustomReportsTeaser-',
};

export const useStyles = makeStyles(styles, options);
